import { S as Swiper } from './swiper-core.min.js';
import { N as Navigation } from './navigation.min.js';
import './create-element-if-not-defined.min.js';

const sectionSelector = '.cs-product-recommendations-section';
const states = new WeakMap();

function resolveSection(target) {
  if (!(target instanceof Element)) return null;
  if (target.matches(sectionSelector)) return target;
  return target.querySelector(sectionSelector);
}

function createSlider(section) {
  const state = states.get(section);
  if (!state || state.instance || !section.isConnected) return;

  const slider = section.querySelector('.swiper');
  if (!slider) return;

  const desktopColumns = Number(slider.dataset.col_pc) || 4;
  const mobileColumns = Number(slider.dataset.col_mb || slider.dataset.col_md) || 2;
  const desktopSpace = Number(slider.dataset.space_pc) || 0;
  const mobileSpace = Number(slider.dataset.space_mb) || 0;
  const groupSlides = slider.dataset.slides_per_group === 'true';
  const desktopSettings = {
    slidesPerView: desktopColumns,
    spaceBetween: desktopSpace,
  };

  if (groupSlides) desktopSettings.slidesPerGroup = desktopColumns;

  const options = {
    modules: [Navigation],
    slidesPerView: mobileColumns,
    spaceBetween: mobileSpace,
    navigation: {
      prevEl: slider.querySelector('.prev-btn'),
      nextEl: slider.querySelector('.next-btn'),
    },
    breakpoints: {
      768: desktopSettings,
    },
  };

  if (groupSlides) options.slidesPerGroup = mobileColumns;
  state.instance = new Swiper(slider, options);
}

function initializeSection(section, immediate = false) {
  if (!section || states.has(section)) {
    if (immediate && section) {
      const state = states.get(section);
      state?.observer?.disconnect();
      if (state) state.observer = null;
      createSlider(section);
    }
    return;
  }

  const state = { instance: null, observer: null };
  states.set(section, state);

  if (immediate || window.Shopify?.designMode || !('IntersectionObserver' in window)) {
    createSlider(section);
    return;
  }

  state.observer = new IntersectionObserver(
    (entries) => {
      if (!entries.some((entry) => entry.isIntersecting)) return;
      state.observer?.disconnect();
      state.observer = null;
      createSlider(section);
    },
    { rootMargin: '400px 0px' },
  );
  state.observer.observe(section);
}

function destroySection(section) {
  const state = states.get(section);
  if (!state) return;
  state.observer?.disconnect();
  state.instance?.destroy(true, true);
  states.delete(section);
}

document.querySelectorAll(sectionSelector).forEach((section) => initializeSection(section));

document.addEventListener('shopify:section:load', (event) => {
  initializeSection(resolveSection(event.target), true);
});

document.addEventListener('shopify:section:unload', (event) => {
  const section = resolveSection(event.target);
  if (section) destroySection(section);
});

document.addEventListener('shopify:block:select', (event) => {
  const section = event.target.closest(sectionSelector);
  if (section) initializeSection(section, true);
});
